import React, { useMemo } from 'react';
import { chain } from 'lodash';
import VoxelAutocomplete, {
  GenericOption,
  VoxelAutocompleteProps,
} from '../../voxel/Forms/VoxelAutocomplete';
import { ProjectGq } from '../../../graphql/projects/models/ProjectGq';

export interface VoxelAutocompleteTagGroupProps
  extends Omit<
    VoxelAutocompleteProps,
    'setSelectedOptions' | 'options' | 'selectedOptionValues' | 'fixedOptions' | 'freeAdd' | 'multi'
  > {
  project: ProjectGq;
  tagGroupId?: number;
  tagIds?: number[];
  setTagIds?: (tagIds: number[]) => void;
}

export const VoxelAutocompleteTagMulti: React.FC<VoxelAutocompleteTagGroupProps> = ({
  project,
  tagGroupId,
  setTagIds,
  tagIds,
  label,
  labelPosition,
  ...forwardedProps
}) => {
  const options = useMemo(() => {
    const tagGroup = project.tagGroups.find((tg) => tg.id === tagGroupId);
    if (!tagGroup) return [];
    return chain(tagGroup.tags)
      .map((tg): GenericOption => ({ title: tg.name, value: tg.id }))
      .orderBy([(t) => t.title, (t) => t.value])
      .value();
  }, [project.tagGroups, tagGroupId]);

  return (
    <VoxelAutocomplete
      {...forwardedProps}
      label={label ?? 'Tags'}
      labelPosition={labelPosition ?? 'top'}
      multi
      options={options}
      selectedOptionValues={tagIds}
      setSelectedOptions={(options) => setTagIds(options.map((opt) => opt.value))}

    />
  );
};

export default VoxelAutocompleteTagMulti;
